import CertificateForm from './components/CertificateForm';
import CertificateTable from './components/CertificateTable';
import {useContext, useEffect, useRef, useState} from 'react';
import DistributionPointSelected from '../../context/MyDistributionPoint';
import {dispensaries as dispensaryServices} from '../../services';
import request from '../../services/request';
import {Spin} from 'antd';


export default function CertificatesPage({ history, location }) {
    const searchParams = new URLSearchParams(location.search);
    const showAdd = searchParams.get('add') === 'true';
    const showEdit = searchParams.get('edit') === 'true';

    const isFetching = useRef(false);
    const { distributionPoint } = useContext(DistributionPointSelected);

    const [distributionPointInfo, setDistributionPointInfo] = useState({});
    // Asegúrate de inicializar equipments como un array
    const [equipments, setEquipments] = useState([]);

    useEffect(() => {
        fetchDistributionPointInfo();
        fetchEquipments();
    }, [distributionPoint]);

    const fetchDistributionPointInfo = () => {
        if (!distributionPoint.id || isFetching.current) return;
        isFetching.current = true;
        dispensaryServices.get(`distributionPoints/${distributionPoint.id}`)
            .then(response => {
                setDistributionPointInfo(response);
            }).catch(error => {
            console.error('Error fetching distribution point info:', error);
        })
            .finally(() => {
                isFetching.current = false;
            });
    };

    const fetchEquipments = () => {
        request().get(`distributionPoints/${distributionPoint.id}/equipments`)
            .then(response => {
                setEquipments(response.data);
            });
    };
    const isAddOrEdit = showAdd || showEdit;
    return (
        <>
            {isAddOrEdit ? (
                <>
                    <CertificateForm
                        key={distributionPoint.id}
                        equipments={equipments}
                        distributionPoint={distributionPointInfo}
                        history={history}
                        location={location}
                    />
                    {equipments.length === 0 && (
                        <Spin size="large" fullscreen />
                    )}
                </>

            ) : (
                <CertificateTable distributionPoint={distributionPoint} history={history} />
            )}
        </>
    );
}
